// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Input_wrapper__3eK3E","input":"Input_input__3F-Ta","label":"Input_label__2SbiV","error":"Input_error__2OZAw"};